var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossredIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 33.125C9.9225 33.125 3.375 26.5775 3.375 18.5C3.375 10.4225 9.9225 3.875 18 3.875C26.0775 3.875 32.625 10.4225 32.625 18.5C32.625 26.5775 26.0775 33.125 18 33.125ZM24.7061 14.2351C24.9806 13.9606 24.9806 13.514 24.7061 13.2395L23.2121 11.7466C22.9376 11.4721 22.491 11.4721 22.2165 11.7466L17.9854 15.9778L13.7542 11.7466C13.4797 11.4721 13.0331 11.4721 12.7586 11.7466L11.2646 13.2395C10.9901 13.514 10.9901 13.9606 11.2646 14.2351L15.4969 18.4674L11.2646 22.6974C10.9901 22.9719 10.9901 23.4185 11.2646 23.693L12.7586 25.187C13.0331 25.4615 13.4797 25.4615 13.7542 25.187L17.9854 20.9548L22.2165 25.187C22.491 25.4615 22.9376 25.4615 23.2121 25.187L24.7061 23.693C24.9806 23.4185 24.9806 22.9719 24.7061 22.6974L20.4739 18.4674L24.7061 14.2351Z",
    fill: "#DC1919"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossredIcon);
export default __webpack_public_path__ + "static/media/crossredIcon.a2e280e92f125b70e9d81020222cd806.svg";
export { ForwardRef as ReactComponent };